/**
 * @title costcodialog.js: Sub-module for Global pages
 * @description This module is used to creating Modal
 * @dependency
 */
define([], function() {
  let dialog = {
	dialogSettings: null,	  
    triggerEvent: null,
    /**
     * Create a BS style modal that is customizable
     * @param  {Object} settings Object with following properties:
     * - title : string appears in the header portion of the modal
     * - body : HTML/string that represents the body of the modal
     * - primary : primary action button name.
     * - secondary : secondary action button name.z
     * - primary_event : OPTIONAL custom event to attach to primary button
     * - url : OPTIONAL url for external link. Used if a primary_event is not provided.
     * @return {void}
     */
    createExtDialogBox: function(settings) {
      // show onetimepopup?
      if (settings.oneTimePopup &&
        this.isPresentInLocalStorage(settings.url)) {
        window.open(settings.url);
        return;
      }
      dialog.showAndHideModal(settings);
    },

    modalObserver: {
      state: {
        STARTED: 'STARTED',
        STOPPED: 'STOPPED'
      },
      observer: null,
      modalObserverState: '',
      elementCausedModal : undefined,
      elementCausedSecondModalId: undefined,
      showingSecondModal: undefined
    },

    /**
     * Function used to watch for changes of costco modal
    */
    returnFocusOnCallerElement: function(activeElement) {
      if(dialog.modalObserver.modalObserverState != dialog.modalObserver.state.STARTED) {
        dialog.modalObserver.modalObserverState = dialog.modalObserver.state.STARTED;
        if (activeElement !== undefined) {
          dialog.modalObserver.elementCausedModal = activeElement;
        }
        let targetObject = COSTCO.dialog.getModal();
        if (targetObject.length > 0){
          targetObject = targetObject[0];
          let observerObject = new MutationObserver(function mutationObjectCallback(mutationRecordsList) {
            mutationRecordsList.forEach(function(mutation) {
               let eventOnClick = false;
              if (event !== undefined) {
                eventOnClick = event.target.onclick ? true : false;
              }
              //On modal close
              if (mutation.target.className === "modal fade" && !dialog.modalObserver.elementCausedSecondModalId && !eventOnClick) {
                $(dialog.modalObserver.elementCausedModal).focus();
                dialog.modalObserver.elementCausedModal = undefined;
                COSTCO.dialog.stopModalObserver();
              } else if (mutation.target.className === "modal fade" && dialog.modalObserver.elementCausedSecondModalId && !eventOnClick) {
            	  dialog.modalObserver.showingSecondModal = undefined;
              } else if (mutation.target.className === "modal fade" && dialog.modalObserver.elementCausedModal && eventOnClick) {
            	  COSTCO.dialog.addParentElementForModalObserver(event.target);
              }
            });
          });
          // Register the target node to observe and specify which DOM changes to watch
          observerObject.observe(targetObject, {
            attributes: true,
            attributeFilter: ["class"]
          });
          if (observerObject) {
            this.modalObserver.observer = observerObject;
          }
        }
      }
    },
    
    addParentElementForModalObserver: function(activeElement) {
    	dialog.modalObserver.elementCausedSecondModalId = activeElement.id;
    	dialog.modalObserver.showingSecondModal = true;
    },
    
    removeParentElementForModalObserver: function(activeElement) {
    	if ($('#' + dialog.modalObserver.elementCausedSecondModalId).get(0)) {
    		$('#' + dialog.modalObserver.elementCausedSecondModalId).get(0).focus();
    		$(document).keyup(function(e) {
    			if (e.key === "Escape") { 
    				$(dialog.modalObserver.elementCausedModal).focus();
    	            dialog.modalObserver.elementCausedModal = undefined;
    	            COSTCO.dialog.stopModalObserver();
    		    }
    		});
    	}
    	
  	  	dialog.modalObserver.elementCausedSecondModalId = undefined;
    },
    
    stopModalObserver: function() {

      dialog.modalObserver.modalObserverState = dialog.modalObserver.state.STOPPED;

      this.modalObserver.observer.disconnect();
    },

    /**
     * Get the Modal for instances where you need to bind certain events
     * @return {jQuery.Object} The costcoModal jquery object
     */
    getModal: function() {
      return $('#costcoModal');
    },
    /**
     * [description]
     * @return {[type]} [description]
     */
    isVisible: function() {
      if ( $('#costcoModal').css('display') == 'none' ){
    	  return false;
      }else{
    	  return $('#costcoModal').is(':visible');   
      }      
    },
    /**
     * [description]
     * @param  {[type]} settings [description]
     * @return {void}          [description]
     */
    showAndHideModal: function(settings) {
    	dialog.captureDataBeforeShowingModal(settings);
      if (COSTCO.dialog.isVisible()) {
        $('#costcoModal').on('hidden.bs.modal', function() {
          // Load up a new modal...
          COSTCO.dialog.showModal(settings);
        });
        $('#costcoModal').modal('hide');
      } else {
        this.showModal(settings);
      }
    },
    /**
     * [description]
     * @param  {[type]} settings [description]
     * @return {void}          [description]
     */
    showModal: function(settings) {
    	dialog.captureDataBeforeShowingModal(settings);
    	//modification for ReturnDialogMOdal.jsp
    	if(settings.url){
    		$('#select-page').addClass('hidden');
    		$('#add-edit-page').removeClass('hidden');
    	}
    	if(settings.hideCloseButton){
    		$('.close').addClass('hidden');
    	}
    	//end modification for ReturnDialogMOdal.jsp
      if (settings.dialogclasses) {
        $('.modal-dialog').addClass(settings.dialogclasses);
      }
      if (settings.hideHeader) {
        $('.modal-header').hide();
      }
      else {
        $('.modal-header').show();
        $('#costcoModalTitle').text(settings.title); 
        var modaltitle = settings.title;
        if (modaltitle == 'Edit Address') {
        	$(".modal-header").find(":button").removeAttr("data-bi-tc");
           	$(".modal-header").find(":button").attr("data-bi-tc", "ui:Edit Shipping Address | X Close");
           	$("#costcoModalBtn2").removeAttr("data-bi-tc");
           	$("#costcoModalBtn2").attr("data-bi-tc", "ui:Edit Shipping Address | Save Address");
           	$(".costcoModalBtn1.btn.btn-tertiary.btn-block").removeAttr("data-bi-tc");
           	$(".costcoModalBtn1.btn.btn-tertiary.btn-block").attr("data-bi-tc","ui:Edit Shipping Address | Cancel");
        }
        if (modaltitle == 'Add New Address') {
       		$(".modal-header").find(":button").removeAttr("data-bi-tc");
       		$(".modal-header").find(":button").attr("data-bi-tc", "ui:Add New Address Modal | X Close");
       		$("#costcoModalBtn2").removeAttr("data-bi-tc");
           	$("#costcoModalBtn2").attr("data-bi-tc", "ui:Add New Address Modal | Save Address");
           	$("#costcoModalBtn1").removeAttr("data-bi-tc");
           	$("#costcoModalBtn1").attr("data-bi-tc", "ui:Add New Address | Cancel");
           	$(".costcoModalBtn1.btn.btn-tertiary.btn-block").removeAttr("data-bi-tc");
           	$(".costcoModalBtn1.btn.btn-tertiary.btn-block").attr("data-bi-tc","ui:Add New Address Modal | Cancel");
        } 
        if (modaltitle == 'Select Address') {
          	$(".modal-header").find(":button").removeAttr("data-bi-tc");
          	$(".modal-header").find(":button").attr("data-bi-tc", "ui:Select Address Modal | X Close");
          	$(".costcoModalBtn1.btn.btn-tertiary.btn-block").removeAttr("data-bi-tc"); 
           	$(".costcoModalBtn1.btn.btn-tertiary.btn-block").attr("data-bi-tc","ui:Select Address Modal | Cancel");
        }
        if (modaltitle == 'Change Pick Up Address') {
        	$(".modal-header").find(":button").removeAttr("data-bi-tc");
        	$(".costcoModalBtn1.btn.btn-tertiary.btn-block").removeAttr("data-bi-tc");
        }
        if(modaltitle == 'Edit Delivery Address' || modaltitle == 'Edit Billing Address'){
        	$(".modal-header").find(":button").removeAttr("data-bi-tc");
        	$(".modal-header").find(":button").attr("data-bi-tc", "ui:Edit Address | Close Button");
        	$("#costcoModalBtn2").removeAttr("data-bi-tc");
           	$("#costcoModalBtn2").attr("data-bi-tc", "ui:Edit Address | Save Address");
           	$("#costcoModalBtn1").removeAttr("data-bi-tc");
           	$("#costcoModalBtn1").attr("data-bi-tc", "ui:Edit Address | Cancel");
        }
        if (settings.close) {
          $('.close').unbind().on('click', function() {
            settings.close();
          });
        }
      }
      // if there is a modal Label specified in the setting used it
      // otherwise we will use the modal title
      if (settings.modalLabel) {
        $('#costcoModal').attr('aria-label',settings.modalLabel);
        $('#costcoModal').removeAttr('aria-labelledby');
      }
      else {
        if(!settings.hideHeader && settings.title) {
          $('#costcoModal').attr('aria-labelledby','costcoModalTitle');
          $('#costcoModal').removeAttr('aria-label');
        }
      }

      $('#costcoModalText').html(settings.body);
      if(settings.replaceFooter) {
    	  $('#costcoModal .modal-footer').html(settings.replaceFooter);
      }
      if (settings.showVerifyMeModal || (settings.primary && (settings.primary_event || settings.url))) {
        $('#costcoModalBtn2').text(settings.primary).show();
        $('#costcoModalBtn2').removeAttr('automation-id');
        $('#costcoModalBtn2').attr('automation-id', settings.primary.replace(/[^a-zA-Z0-9]/g, '').toLowerCase() + "_button");
        if (settings.primary_button_style !== undefined && settings.primary_button_style.includes('rounded')) {
          $('#costcoModalBtn2').addClass('primary-button-v2');
        }
        //since primary button is visible, make the secondary button half the row again
        if(settings.secondary != undefined || settings.setHalfButtons){
            $('.costcoModalBtn1').parent('.col-md-12').removeClass('col-md-12').addClass('col-md-6');
            $('#costcoModalBtn2').parent('.col-md-12').removeClass('col-md-12').addClass('col-md-6');
            $('.costcoModalBtn1').parent('.col-lg-12').removeClass('col-lg-12').addClass('col-lg-6');
            $('#costcoModalBtn2').parent('.col-lg-12').removeClass('col-lg-12').addClass('col-lg-6');
        } else {
            $('#costcoModalBtn2').parent('.col-md-6').removeClass('col-md-6').addClass('col-md-12');
            $('#costcoModalBtn2').parent('.col-lg-6').removeClass('col-lg-6').addClass('col-lg-12');
        }
        if(settings.showVerifyMeModal){
        	$('#costcoModalBtn2').html(settings.showVerifyMeModalText);
        	$('#costcoModalBtn2').addClass('verify-me-button');
        	$('#costcoModalBtn2').removeClass('primary-button-v2');
        	$('#costcoModalBtn2').removeClass('btn-primary');
        	$('#costcoModalBtn2').addClass('no-padding');
        }else{
        	$('#costcoModalBtn2').removeClass('verify-me-button');
        }
      } else {
        $('#costcoModalBtn2').hide();
        //since primary event button is hidden, make the secondary button span the whole row
        $('.costcoModalBtn1').parent('.col-md-6').removeClass('col-md-6').addClass('col-md-12');
        $('.costcoModalBtn1').parent('.col-lg-6').removeClass('col-lg-6').addClass('col-lg-12');
      }
      if (settings.secondary_button_style !== undefined && settings.secondary_button_style.includes('rounded')) {
        $('.costcoModalBtn1').addClass('secondary-button-v2');
      } else if (settings.secondary_button_style !== undefined && settings.secondary_button_style.includes('tertiary')) {
        $('.costcoModalBtn1').addClass('tertiary-alternative-button-v2');
        $('.costcoModalBtn1').removeClass('btn-tertiary secondary-button-v2');
      }
      
      if(settings.hideFooter) {
        $('.modal-footer').hide();
      }
      else {
        $('.modal-footer').show();
      }
      if (settings.primaryDisabled) {
        $('#costcoModalBtn2').addClass('btn-disabled');
      } else {
        $('#costcoModalBtn2').removeClass('btn-disabled');
      }
      if (settings.secondary) {
        $('.costcoModalBtn1').text(settings.secondary).show();
      } else {
        $('.costcoModalBtn1').hide();
      }
      if (settings.close) {
        $('.close').unbind().on('click', function() {
			//modification for ReturnDialogMOdal.jsp
        	if(settings.url == undefined){
        		$('#select-page').removeClass('hidden');
        		$('#add-edit-page').addClass('hidden');
        	}
			//end modification for ReturnDialogMOdal.jsp

			settings.close();
        });
      }
      
      
      
      if (settings.footerText) {
        $('#costcoModalFooterText').html(settings.footerText);
        $('#costcoModalFooterText').removeClass('hide');
      } else {
        $('#costcoModalFooterText').addClass('hide');
      }
      // Hides the default modal footer and shows the alternate modal footer
             if (settings.footerText2) {
              $('#costcoModalFooterText2').html(settings.footerText2);
              $('#costcoModalFooterText2').removeClass('hide');
            } else {
              $('#costcoModalFooterText2').addClass('hide');
            }

      $('#commercial-indicator, #residental-indicator').unbind().on('keydown keypress', function(event) {
          if (event.which === 32) {
            $(this).click();
          } else if (event.which === 38 || event.which === 40) { //cursors up and down
            let $controlIndicators = $(this).closest('.control-group').find('.control__indicator');
            let total = $controlIndicators.length;
            let index = $controlIndicators.index(this);
            if (event.which == 38) { //cursor up
              index = (index == 0) ? total - 1 : index - 1;
            } else if (event.which == 40) { //cursor down
              index = (index + 1) % total;
            }
            $controlIndicators[index].click();
          }
      });

      $('#commercial-indicator, #residental-indicator').unbind('click').on('click', function(event) {
        if ($(event.target).hasClass('control__indicator')) {
          let passiveElement = $(event.target).attr('id') === "commercial-indicator" ? $('#residental-indicator') : $('#commercial-indicator');
          COSTCO.dialog.setRadioButtonsAttributes($(event.target), passiveElement)
        }
        $(event.target).find('input').click();
      });

      $('#costcoModalBtn2').unbind().on('click', function() {
    	  if (COSTCO.timeoutModal && COSTCO.timeoutModal.state === COSTCO.timeoutModal.TIMEDOUT) {
    		var url="ReLogonFormView?URL="+window.location.pathname;
          	document.location.href = url;
           } 
        if (settings.primary_event) {
	      if(settings.primary == 'View List' || settings.primary == 'Voir la liste'){
        	  COSTCO.Global.updateSelectedMenuItem('Lists.label');
	      }
          settings.primary_event();
        } else {
          $('#costcoModal').modal('hide');
          if (settings.url) {
            window.open(settings.url);

            // check for onetimepopup and add to local storage
            if (settings.oneTimePopup) {
              COSTCO.util.setInStorage(settings.url, {
                'url': settings.url,
              });
            }
          }
        }
      });
      $('.costcoModalBtn1').unbind().on('click', function() {
		//modification for ReturnDialogMOdal.jsp
    	if(settings.url == undefined){
      		$('#select-page').removeClass('hidden');
      		$('#add-edit-page').addClass('hidden');
      	}
		//end modification for ReturnDialogMOdal.jsp

        if (settings.secondary_event) {
          settings.secondary_event();
        } else {
          $('#costcoModal').modal('hide');
        }
      });
      if (settings.popover) {
    	  $('#costcoModal').find('[data-toggle="popover"]').popover();
      }
      this.bindEvents(settings);
      $('#costcoModal').modal({
        backdrop: settings.preventClose ? 'static' : true,
        keyboard: settings.preventClose ? false : true,
        show: true,
      });
      //Handle page load by opening in new tab
      $('#costcoModal').show();	
	  $('#costcoModal').css('display', 'block');
	  
	},
    
    sameAddressValidation: function(formSelector, fieldSelector) {
    	var addressEnteredForCheck = $('#addressEnteredForCheck').val();
        $(fieldSelector).val(addressEnteredForCheck);
        $(fieldSelector).focus();
        var forms = $(fieldSelector).parents('FORM');
        var addressEnteredForCheck2 = $('#addressEnteredForCheck2');
        if(forms.length && addressEnteredForCheck2.length){
        	var form = $(forms[0]);
        	var address2 = addressEnteredForCheck2.val();
        	var city = $('#addressEnteredForCheckCity').val();
        	var state = $('#addressEnteredForCheckState').val();
        	var postalCode = $('#addressEnteredForCheckPostalCode').val();
        	var formFields = form.find('INPUT[type="text"]');
        	for(var i=0;i<formFields.length;i++){
        		var field = formFields[i];
        		if(/address2/.test(field.name)){
        			field.value = address2;
        		} else if(/city/.test(field.name)){
        			field.value = city;
        		} else if(/.*(zip|postal).*/.test(field.name)){
        			field.value = postalCode;
        		}
        	}
        	formFields = form.find('SELECT');
        	for(var i=0;i<formFields.length;i++){
        		var field = formFields[i];
        		if(/.*(province|state).*/.test(field.name)){
        			field.value = state;
        		}
        	}
        }
    	$.validator.addMethod("sameAddressValidationRule", function (inputValue) {
            return addressEnteredForCheck === inputValue ? false : true;
        }, messages.ERR_SHIP_ADDR_SAME_AS_WHS_ADDR_FIELD_VALIDATION);

        $(formSelector).validate().resetForm();
        $(formSelector).validate();
        $(fieldSelector).rules('add', 'sameAddressValidationRule');
        $(fieldSelector).valid();
    },
    
    /**
     * Updates the modal title, body, buttons, bindings etc without closing the modal
     * @param  {Object} settings @see COSTCO.dialog.createExtDialogBox()
     */
    updateModal: function(settings) {
      dialog.showModal(settings);
    },
    /**
     * [description]
     * @return {void} [description]
     */
    close: function() {
      $('#costcoModal').modal('hide');
      dialog.returnFocusOnPreviousElement();
    },
    /**
     * [description]
     * @return {void} [description]
     */
    closeAndUnbind: function() {
      $('#costcoModal').unbind('shown.bs.modal');
      $('#costcoModal').unbind('hidden.bs.modal');
      $('#costcoModal').unbind('hide.bs.modal');
      this.close();
    },
    /**
     * Binds the "hidden/shown" events (ie modal is closed/opened) with some
     * clear/show actions. Additionally you can pass a function as part
     * of your settings object to execute custom thangs.
     * @param  {Object} settings  The settings object that contains
     *                            the event handlers used for various
     *                            modal actions.
     * @return {void}
     */
    bindEvents: function(settings) {
      $('#costcoModal').unbind('shown.bs.modal').on('shown.bs.modal', function(e) {
        // This event is fired when the modal has been made visible to the user
        // (will wait for CSS transitions to complete). If caused by a click,
        // the clicked element is available as the relatedTarget property of
        // the event.
        if (settings.onshown) settings.onshown(e);
        if (dialog.modalObserver.elementCausedSecondModalId && !e.target.onclick && !dialog.modalObserver.showingSecondModal) {
        	COSTCO.dialog.removeParentElementForModalObserver();
        };
        COSTCO.util.trapFocusInsideModal();
      });
      $('#costcoModal').unbind('hidden.bs.modal').on('hidden.bs.modal', function(e) {
        if (typeof settings.dialogclasses != 'undefined') {
          $('.modal-dialog').removeClass(settings.dialogclasses);
        }
        // clear and show. Execute fn if it exists
        if (settings.onclose) settings.onclose(e);
        $('#costcoModalTitle').empty().show();
        if($('#react-video-holder').length && $('#videoViewer-popup').length)
        	$('#react-video-holder').append($('#videoViewer-popup'));
        $('#costcoModalText').empty().show();
        $('.costcoModalBtn1').empty().show();
        $('#costcoModalBtn2').empty().show();

        if (settings.afterclose) settings.afterclose(e);
      });
      $('#costcoModal').unbind('show.bs.modal').on('show.bs.modal', function(e) {
	    if (settings.onshow) settings.onshow(e);
	  });
      $('#costcoModal').unbind('hide.bs.modal').on('hide.bs.modal', function(e) {
        // This event is fired when the modal is going to close.
        if (settings.onhide) settings.onhide(e);
      });
    },
    /**
     * [description]
     * @param  {[type]} hostname [description]
     * @return {boolean}
     */
    isPresentInLocalStorage: function(hostname) {
      if (JSON.stringify(COSTCO.util.getFromStorage(hostname)).indexOf(hostname) > 0) {
        return true;
      } else {
        return false;
      }
    },
    /**
     * Holds previous options object used to instantiate a modal with.
     * This is the modal stack used by modalStack function.
     * @type {Array}
     */
    modalStackPreviousOptions: [],
    /**
     * Create a sequential stack of modals by calling this function
     * successively.
     *  ex.
     *    1. COSTCO.dialog.modalStack({title:'hi', body:'robert'})
     *      -> Invoke a hi-robert modal, pushes options to stack.
     *    2. COSTCO.dialog.modalStack({title:'hi', body:'kurt'})
     *      -> Closes the hi-robert modal and invokes/pushes the hi-kurt
     *         modal to stack.
     *    3. (Escape key, Exit Arrow, or blur)
     *      -> Pops the currently invoked modal from the stack and
     *         closes it. Invokes the previous modal from the stack
     *         until the stack b gone or we call this function again.
     * @param  {Object} options The settings object for the modal.
     * @return {void}
     */
    modalStack: function(options) {
      let stack = this.modalStackPreviousOptions;
      options.index = stack.length + 1;
      stack.push(options);
      options.afterclose = function() {
        let stack = dialog.modalStackPreviousOptions;
        if (stack.length === this.index && stack.length !== 1) {
          // we need to go backward
          dialog.showAndHideModal(stack[this.index - 2]);
          COSTCO.dialog.modalStackPreviousOptions.pop();
        } else if (stack.length > this.index) {
          dialog.showAndHideModal(stack[this.index]);
        } else {
          COSTCO.dialog.clearStack();
        }
      }.bind(options);
      if (stack.length === 1) {
        this.showAndHideModal(options);
      } else {
        this.close();
      }
    },

    /**
     * set radio buttons attributes
     */
    setRadioButtonsAttributes: function(activeElement, passiveElement) {
      activeElement.addClass('active').attr('aria-checked', true).find('div').removeClass('hide');
      passiveElement.removeClass('active').attr('aria-checked', false).find('input').removeAttr('checked');
      passiveElement.find('div').addClass('hide');
    },

    /**
     * Clears the modal stack.
     * @return {void} [description]
     */
    clearStack: function() {
      this.modalStackPreviousOptions = [];
    },
    /*
     * Listener for opening/closing modals 
     * to help with returning focus to original 
     * element or input 
     */
    initializeReturnFocusListener: function(){
    	$(document).on('hidden.bs.modal', '#costcoModal', function (e) {
	        dialog.returnFocusOnPreviousElement();
		});
    	$(document).on('shown.bs.modal', '#costcoModal', function (e) {
	        dialog.returnFocusOnInput();
		});
    },
    /*
     * This function utilizes the triggerEvent variable
     * to return focus on elements 
     */
    returnFocusOnPreviousElement: function() {
      let previousElement = null;
      if(dialog.triggerEvent != null){
    	  previousElement = dialog.triggerEvent.srcElement;
      } else if(dialog.triggerEvent == null &&
    		  COSTCO.timeoutModal != null &&
    		  COSTCO.timeoutModal.lastActiveElement != null){
    	  previousElement = COSTCO.timeoutModal.lastActiveElement;
      } else {
    	  previousElement = $('body');
      }
    	  $(previousElement).focus();
    },
    
    /*
     * This function's use case is to return 
     * focus to the element within a modal
     */
    returnFocusOnInput: function(){
    	let previousElement = null;
    	if(COSTCO.timeoutModal != null &&
			  COSTCO.timeoutModal.lastActiveElement != null &&
			  dialog.dialogSettings.title !== messages.TIMEOUT_MODAL_HEADER){
    		previousElement = COSTCO.timeoutModal.lastActiveElement;
    		COSTCO.timeoutModal.lastActiveElement = null;
      }
    	$(previousElement).focus();
    },
    
    /*
     * This function captures 
     */
    triggerEventUtil: function(){
    	if(window.event !== undefined){
    	  if(dialog.getSettings() != null &&
    			  dialog.getSettings().title === messages.BD_QUESTIONNAIRE_TITLE){
    		  return;
    	  } else if(dialog.getSettings() != null &&
    			  dialog.getSettings().title === messages.TIMEOUT_MODAL_HEADER){
    		  return;
    	  }	 else {
      	  dialog.triggerEvent = window.event;
        }
        }
    },
    /*
     * returns the current dialog's settings
     */
    getSettings: function() {
    	return dialog.dialogSettings;
    },
    /*
     * Captures data upon opening a modal
     * to grab the event and copy settings
     */
    captureDataBeforeShowingModal: function(settings){
    	dialog.triggerEventUtil();
    	dialog.dialogSettings = settings;
    }

  }; // end costcoDialog object
  // Expose costcoDialog to the global scope.
  if (typeof window.COSTCO === 'undefined') {
    window.COSTCO = {};
  }
  window.COSTCO.dialog = dialog;
  return dialog;
});



// WEBPACK FOOTER //
// ./js/global/costcodialog.js